// EmptyState — a friendly "nothing here yet" panel with an optional icon and
// call-to-action. Token-driven + dark-aware. Prefer an <Icon> for the icon
// (crisp, on-brand) over an emoji.
//
//   <EmptyState
//     icon={<Icon name="placement" size={26} />}
//     title="No active placements yet"
//     description="Placements appear here when a candidate is placed."
//     action={<Button onClick={openKanban}>Open Kanban</Button>}
//   />

import { ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** A ready-made action element (e.g. a <Button>). */
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={['ui-empty', className].filter(Boolean).join(' ')}>
      {icon && <div className="ui-empty__icon" aria-hidden>{icon}</div>}
      <div className="ui-empty__title">{title}</div>
      {description && <div className="ui-empty__desc">{description}</div>}
      {action}
    </div>
  );
}
